import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LADAAT_SERVER } from 'src/environments/environment';
import { Answer } from '../modules/settings/test/test.component';


@Injectable({
  providedIn: 'root'
})
export class PopupService {

    clickButn = new Subject()

    constructor(){}


    



}